import { Container } from '@chakra-ui/react';
import { useResendBoaShareLinkMutation } from '@client/graphql/__generated__/main-operations';
import { BuyerOfferAnalysisProvider } from '../../components/BuyerOfferAnalysis/Context/BuyerOfferAnalysisContext';
import { OfferScorecard } from '../../components/OfferScorecard/OfferScorecard';
import { SharedPage } from '../SharedPage/SharedPage';

export const BOABuyerViewPage = () => {
  const [resendBOAShareLink, { loading }] = useResendBoaShareLinkMutation();

  const resendLink = async (token: string) => {
    await resendBOAShareLink({ variables: { token } });
  };

  return (
    <SharedPage isResendingLink={loading} resendLink={resendLink}>
      <Container maxWidth="100vw" p={0}>
        <BuyerOfferAnalysisProvider isViewOnly>
          <OfferScorecard />
        </BuyerOfferAnalysisProvider>
      </Container>
    </SharedPage>
  );
};
